import React from 'react';

import cx from 'classnames';
import { Icon } from 'design-system-web';

import { S } from 'components/typography';

import { useLabels } from '../../i18n/useLabels';
import { useCustomizationDispatch } from '../../state/useCustomizationDispatch';
import type { SectionViewModel } from '../../viewmodels/createSectionViewModel';
import { Badge } from '../badges/Badge';

import styles from './SectionAccordion.scss';

type Props = {
  viewModel: SectionViewModel;
};

export function SectionHeader({ viewModel }: Props) {
  const labels = useLabels();
  const dispatch = useCustomizationDispatch();

  const handleToggle = () => {
    dispatch({ type: 'SECTION_TOGGLED', sectionId: viewModel.id });
  };

  return (
    <div className={styles.header}>
      <button
        type="button"
        className={styles.toggle}
        aria-expanded={viewModel.isExpanded}
        data-test="section-toggle"
        onClick={handleToggle}
      >
        <Icon name={viewModel.isExpanded ? 'chevron-down' : 'chevron-right'} />
        <span className={cx(viewModel.isHidden && styles.hidden)}>
          {viewModel.name}
        </span>
      </button>
      {viewModel.badges.map(badge => (
        <Badge key={badge.kind} viewModel={badge} />
      ))}
      <S variant="secondary">{labels.formatMessage(viewModel.counts)}</S>
    </div>
  );
}
